import React,{ useState, useEffect } from 'react'
import "./CreateUsers.css"
import CreateUserTemplate from '../modalForm/CreateUserTemplate';
import Slide from '@mui/material/Slide';
import { useDispatch } from "react-redux";
import $ from 'jquery';
import { createUser, getUser, updateUserById, deleteUserById, reSentMail } from "./../../../../services/global_redux/globale_actions/Login.action"
import { getRole,getUserRole} from "./../../../../services/global_redux/globale_actions/Role.action"
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import mainIcon from "../../../../assets/global_assets/user_imgs/main_icon.png";
import delete_icon from '../../../../assets/reUsableTemplates_assets/delete_icon.png';
import download_icon from '../../../../assets/reUsableTemplates_assets/dowload_icon.png';
import arrow_up from "../../../../assets/global_assets/reusable-table-imgs/arrow_up.png"
import arrow_down from "../../../../assets/global_assets/reusable-table-imgs/arrow_down.png"
import slno_icon from "../../../../assets/global_assets/holiday_table/slno.png"
import action_icon from "../../../../assets/global_assets/holiday_table/action.png"

import Created_date_icon from "../../../../assets/global_assets/user_imgs/Created_date.png"
import mail_icon from "../../../../assets/global_assets/user_imgs/mail_icon.png"
import mail_notification_icon from "../../../../assets/global_assets/user_imgs/mail_notification_icon.png"
import Role_name_icon from "../../../../assets/global_assets/user_imgs/Role_name_icon.png"
import User_id_icon from "../../../../assets/global_assets/user_imgs/User_id.png"
import user_name_icon from "../../../../assets/global_assets/user_imgs/user_name.png"
import table_delete_icon from "../../../../assets/global_assets/reusable-table-imgs/table_delete_icon.png"
import table_edit_icon from "../../../../assets/global_assets/reusable-table-imgs/table_edit_icon.png"
import use_default_dp from "../../../../assets/global_assets/user_imgs/user_dp_icon.png"
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CreateUsers({ showSnackbar, setLoading }) {
    const dispatch = useDispatch();

    const [createopen, setcreateOpen] = React.useState(false);
    const createmodalhandleOpen = () => setcreateOpen(true);
    const createmodalhandleClose = () => setcreateOpen(false);
    const [roleData, setRoleData] = React.useState([])
    const [editableRow, setEditableRow] = useState(null);
    const [editedValues, setEditedValues] = useState({});
    const [userData, setUserData] = React.useState([])
    const [sendmail, setsendmail] = useState();
    const [openUserdeletealert, setopenUserdeletealert] = useState(false);
    const user_data = JSON.parse(sessionStorage.getItem('user'));
    const currentUserBaseRole = user_data.base_role;
    const [shouldShowAdminSelect,setshouldShowAdminSelect]=useState(false)
    const [createformValues, setcreateFormValues] = useState({
      user_name: '',
      user_email: '',
      role_name: '',
      mail_sent: '1',
      assigned_admin_id:"",
      company_code :user_data.company_code
    });
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [checkedItems, setCheckedItems] = useState({});
    const [opendeletealert, setopendeletealert] = useState(false);
    const [deletesingleID, setdeletesingleID] = useState({});
    const [isSuperAdmin,setIsSuperAdmin] = useState(false);
    
    const [createData, setCreateData] = useState(false);
    const [editData, setEditData] = useState(null);
    const [deleteData, setDeleteData] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [openeditalert, setOpeneditalert] = useState(false);
    const [actionChecked, setActionChecked] = useState("");
  
const handleCheckAll = () => {
  const newCheckedItems = { ...checkedItems };
  const visibleRows = $('#dataTable tbody tr:visible');

  const allVisibleChecked = visibleRows.toArray().every(row => {
      const id = $(row).data('id');
      return checkedItems[id];
  });

  const shouldCheck = !allVisibleChecked;

  visibleRows.each(function () {
      const id = $(this).data('id');
      newCheckedItems[id] = shouldCheck;
  });

  setCheckedItems(newCheckedItems);
};
const header = [
  { key: "role_name", value: "Role Name", input: "none", icon: Role_name_icon, dataIcon: false, highlightName: false, isEditable: true },
  { key: "user_email", value: "Mail ID", input: "text", icon: mail_icon, dataIcon: false, highlightName: false, isEditable: true },
  { key: "user_name", value: "User Name", input: "text", icon: user_name_icon, dataIcon: false, highlightName: false, isEditable: false },
  ...(isSuperAdmin
    ? [
        {
          key: "assigned_admin_id",
          value: "Reporting Manager",
          input: "none",
          icon: Created_date_icon,
          dataIcon: false,
          highlightName: false,
          isEditable: true,
        },
      ]
    : []),
  { key: "mail_sent", value: "Mail Notification", input: "text", icon: mail_notification_icon, dataIcon: false, highlightName: true, isEditable: false },
];

    
function formatDateForInput(dateString) {
  // Try to create a Date object from the provided date string
  const date = new Date(dateString);

  // Check if the date is invalid
  if (isNaN(date.getTime())) {
      console.error("Invalid date string:", dateString);
      return null; // or handle the error as needed
  }

  return date.toISOString().split('T')[0];
}
function formatDate(dateString) {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
      // Handle the case where dateString is invalid
      return "Invalid Date";
  }

  const options = { day: '2-digit', month: 'short', year: 'numeric' };
  return new Intl.DateTimeFormat('en-GB', options).format(date).replace(/ /g, '-');
}
    const [checkRoles , setCheckRoles] = useState([]);
    const [adminUserNames ,setAdminUserNames] = useState([]);
    const [allAdminroles,setAllAdminroles] = useState([]);
    const [activeTab, setActiveTab] = useState(null);
    useEffect(() => {
      const savedTab = sessionStorage.getItem('activeTab') || "register";
      setActiveTab(savedTab);
    }, []);
    const createmodalhandleChange = (e) => {
      const { name, value } = e.target;
    //   setcreateFormValues((prevValues) => ({
    //     ...prevValues,
    //     [name]: value,
    //   }));

    if (name === "role_name") {
        const isAdmin = adminUserNames.includes(value);
        const resetAssignedAdmin = isAdmin ? { assigned_admin_id: "" } : {};
        setcreateFormValues((prev) => ({
          ...prev,
          [name]: value,
          ...resetAssignedAdmin,
        }));
        setshouldShowAdminSelect(!adminUserNames.includes(value));
      } else {
        const trimmedValue = value.replace(/^\s+/, "");
        setcreateFormValues((prev) => ({
          ...prev,
          [name]: trimmedValue,
        }));
      }
    };
    const sendsermail = async (id) => {
      setLoading(true);
      setsendmail({
        auth_id: id
      });
      try {
        const response = await dispatch(
          reSentMail(({
            auth_id: id
          }))
        );
        if (response.success == true) {
          showSnackbar(response.message, "success");
          setLoading(false);
          FetchUser()
        }else if(response.success == false){
          showSnackbar(response.message, "error");
          setLoading(false);
          FetchUser()
        } else {
          showSnackbar(response.message, "warning");
          setLoading(false);
        }
      } catch (error) {
        showSnackbar("An error occurred", "error");
        setLoading(false);
      }
      setEditableRow(null);
    }
    

  const handleFetchRole = async () => {
    try {
      const response = await dispatch(getRole());
      setAdminUserNames(response.data.filter((data)=> data.base_role === "Admin" && data.base_role !== "vendor").map((data)=> data.role_name));
        if(currentUserBaseRole === "SuperAdmin"){
            setIsSuperAdmin(true);
            setRoleData(response.data.filter((data)=> data.base_role !== "SuperAdmin" && data.base_role !== "vendor"));
            setCheckRoles(response.data.filter((data)=> data.base_role !== "SuperAdmin" && data.base_role !== "vendor").map((data)=> data.role_name));
        }else if(currentUserBaseRole === "Admin"){
          setcreateFormValues({
            assigned_admin_id:user_data.user_id
          })
            setRoleData(response.data.filter((data)=> data.base_role !== "SuperAdmin" &&  data.base_role !== "Admin" && data.base_role !== "vendor" ));
            setCheckRoles(response.data.filter((data)=> data.base_role !== "SuperAdmin" &&  data.base_role !== "Admin" && data.base_role !== "vendor" ).map((data)=> data.role_name));
        }else if(currentUserBaseRole === "Processor"){
            setcreateFormValues({
              assigned_admin_id:user_data.user_id
            })
            setRoleData(response.data.filter((data)=> data.base_role === "Client"));
            setCheckRoles(response.data.filter((data)=> data.base_role === "Client").map((data)=> data.role_name));
        }else{
            setRoleData(null);
            setCheckRoles(null);
        }
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };
  useEffect(() => {
    handleFetchRole();
  }, [dispatch]);
  const createmodalhandleSubmit = async (e) => {
    e.preventDefault();
    const email = createformValues.user_email?.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)){
        showSnackbar("Please enter a valid Mail ID", "warning");
        return;
    }
    const nameRegex = /^[a-zA-Z.'\s-]+$/;
    const name = createformValues.user_name?.trim()
    if (!nameRegex.test(name)){
      showSnackbar("Enter a Valid User Name", "warning");
      return;
    }
    const send_data_to_create = {
        ...createformValues,
    }
    if(!send_data_to_create.mail_sent){
      send_data_to_create.mail_sent = "1";
    }
    if(currentUserBaseRole !== "SuperAdmin"){
      send_data_to_create.assigned_admin_id = user_data.user_id;
      send_data_to_create.company_code = user_data.company_code;
    }

    setLoading(true);
    createmodalhandleClose();
    try {
      const response = await dispatch(createUser(send_data_to_create));
      setLoading(false);
      FetchUser("create");
      if (response.success == true) {
          setcreateFormValues({
              user_id: '',
              user_name: '',
              user_email: '',
              role_name: '',
              mail_sent: '1',
              company_code :user_data.company_code,
              assigned_admin_id:""
            });
        showSnackbar(response.message, "success");
      } else {
        showSnackbar(response.message, "warning");
      }
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };
    const handleEditClick = (id) => {
      const item = userData.find((d) => d.auth_id === id);
      setEditableRow(id);
      setEditedValues({ ...item });
    };
    const handledeleteuserClickOpenalert = (id) => {
      setopenUserdeletealert(true);
      setuserdeleteid(id)
    };
    const [deleteuserid, setuserdeleteid] = useState(null);
    const handleSaveClick = async (e) => {
      const fieldLabels = {
          user_email: "Mail ID",
          role_name: "Role Name"
        };
      const requiredFields = ["user_email", "role_name"];
      const missingFields = requiredFields.filter(
        (field) => !editedValues[field] || editedValues[field].toString().trim() === ""
      );
      if (missingFields.length > 0) {
        const missingFieldLabels = missingFields.map(
        (field) => fieldLabels[field] || field
      );
      showSnackbar(`Please fill all required fields: ${missingFieldLabels.join(", ")}`, "warning");
        return;
      }
      if(currentUserBaseRole !== "SuperAdmin"){
        editedValues.assigned_admin_id = user_data.user_id
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const email = editedValues.user_email?.trim();
      if (!emailRegex.test(email)){
        showSnackbar("Please enter a valid Mail ID", "warning");
        return;
      }
      setLoading(true);
      try {
        const response = await dispatch(
          updateUserById(editedValues.auth_id, editedValues)
        );
        
        if (response.success) {
          showSnackbar(response.message, "success");
          setLoading(false);
          FetchUser()
        } else {
          showSnackbar(response.message, "warning");
          setLoading(false);
        }
      } catch (error) {
        showSnackbar("An error occurred", "error");
        setLoading(false);
      }
      setEditableRow(null);
    };
    const handleCancelClick = () => {
      setEditableRow(null);
      setEditedValues({});
    };
    const handleInputChange = (e) => {
      const { name, value } = e.target;
    //   setEditedValues({
    //     ...editedValues,
    //     [name]: value,
    //   });
    if (name === "role_name") {
        const isAdmin = adminUserNames.includes(value);
        const resetAssignedAdmin = isAdmin ? { assigned_admin_id: "" } : {};

        setEditedValues((prev) => ({
          ...prev,
          [name]: value,
          ...resetAssignedAdmin,
        }));

        setshouldShowAdminSelect(!isAdmin);
      } else {
        setEditedValues((prev) => ({
          ...prev,
          [name]: value,
        }));
      }

    };

    useEffect(() => {
        FetchUser();
      }, [dispatch]);

  const handleDeleteClick = async () => {
    setLoading(true);
    setopenUserdeletealert(false);
    try {
      const response = await dispatch(deleteUserById(deleteuserid));
      if (response.success) {
        showSnackbar(response.message, "success");
        setLoading(false);
        FetchUser("delete");
      } else {
        showSnackbar(response.message, "warning");
        setLoading(false);
      }
    } catch (error) {
      showSnackbar("An error occurred", "error");
      setLoading(false);
    }
    setEditableRow(null);
  };
  const handleuserdeleteClosealert = () => {
    setopenUserdeletealert(false);

  }
  const data = userData;


  const handledeletealert = (id) => {
    setopendeletealert(true)
    setdeletesingleID(id)
  }
  
// pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
const indexOfLastRecord = currentPage * recordsPerPage;
const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
const [selectedClient, setSelectedClient] = useState('');
const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
const filteredData1 = selectedClient
  ? data.filter(item => item.unit_id === selectedClient)
  : data;
  const filteredData = Array.isArray(filteredData1)
  ? filteredData1.filter(item =>
      Object.values(item).some(value =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    )
  : [];
const sortedData = Array.isArray(filteredData) && filteredData.length > 0
? [...filteredData].sort((a, b) => {
  if (!sortConfig?.key) return 0;
  const valueA = a[sortConfig.key] || "";
  const valueB = b[sortConfig.key] || "";

  if (typeof valueA === "number" && typeof valueB === "number") {
      return sortConfig.direction === "asc" ? valueA - valueB : valueB - valueA;
  } else {
      return sortConfig.direction === "asc"
          ? valueA.toString().localeCompare(valueB.toString())
          : valueB.toString().localeCompare(valueA.toString());
  }
})
: [];
const currentRecords = sortedData.slice(indexOfFirstRecord, indexOfLastRecord);
const totalPages = Math.ceil(sortedData.length / recordsPerPage);
const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
        setCurrentPage(pageNumber);
    }
};
const FetchUser = async (type) => {
      try {
        const response = await dispatch(getUser());
        if(currentUserBaseRole === "SuperAdmin"){
          setUserData(response.data.filter(data=>data.user_id !== user_data.user_id));
          setActionChecked(type); 
        }else{
            setUserData(response.data.filter(data => data.assigned_admin_id === user_data.user_id && data.user_id !== user_data.user_id));
            setActionChecked(type); 
        }
      } catch (err) {
        console.error("Failed to fetch states:", err);
      }
    };
    useEffect(()=>{
        if(actionChecked === "create"){
          setCurrentPage(totalPages);
          setActionChecked("");
    
        }else if(actionChecked === "delete"){
          if(currentPage != 1 && currentPage > totalPages){
            setCurrentPage(totalPages);
          setActionChecked("");
          }
        }else{
          setActionChecked("");
        }
      },[actionChecked,totalPages])
const getPageSizeOptions = (totalEntries) => {
  const options = [ 10, 20, 50, 100,200,300,400,500,600,];
  const filtered = options.filter(size => size < totalEntries);

  return [...filtered, totalEntries];
};
// sort funtion starts
const handleSort = (key) => {
  setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
  }));
};

const getSortIcon = (key) => {
  if (sortConfig.key !== key) return "";
  return sortConfig.direction === "asc" ? arrow_up : arrow_down;
};
// sort funtion ends
const calculateWidth = (text) => {
  const charWidth = 11;
  return `${text.length * charWidth}px`;
};


const renderCell = (item, headerItem) => {
  const isEditing = editableRow === item.auth_id;
  const value = item[headerItem.key];
  let content;

  if (headerItem.input === "date") {
    content = isEditing && headerItem.isEditable === true ? (
      <input
        type="date"
        name={headerItem.key}
        value={formatDateForInput(editedValues[headerItem.key] || value)}
        onChange={handleInputChange}
        readOnly={headerItem.readOnly}
      />
    ) : formatDate(value); 
  } 
  else if (headerItem.key === "role_name") {
    content = isEditing && headerItem.isEditable === true ? (
      <select
          value={editedValues.role_name}
          name="role_name"
          onChange={handleInputChange}
      >
          <option value="">--select--</option>
          {roleData.map((item) => (
              <option value={item.role_name}>{item.role_name}</option>
          ))}
      </select>
    ) : value || "N/A";
  } 
  else if (headerItem.key === "assigned_admin_id") {
    content = isEditing && headerItem.isEditable === true ? (
      shouldShowAdminSelect || !adminUserNames.includes(editedValues.role_name) ? (
        <select
          name="assigned_admin_id"
          value={editedValues.assigned_admin_id || ""}
          onChange={handleInputChange}
        >
          <option value="">--select--</option>
          {userData.filter(item => adminUserNames.includes(item.role_name)).map((item) => (
                <option value={item.user_id}>{item.user_id}</option>
            ))}
        </select>
      ) : (
        <span className="text-muted">—</span> // or empty/hidden
      )
    ) : value || "N/A";
  } 
  else {
    content = isEditing  && headerItem.isEditable === true ? (
      <input
        type={headerItem.input}
        name={headerItem.key}
        value={editedValues[headerItem.key] || ""}
        onChange={handleInputChange}
        readOnly={headerItem.readOnly}
      />
    ) : value;
  }
  

  if (isEditing  && headerItem.isEditable === true) {
    return content;
  } else {if(headerItem.key === "user_name"){
    return (
      <span className="d-flex align-items-center" style={{ whiteSpace:"nowrap" }}>
        <img
          src={item.user_dp || use_default_dp}
          alt="dp"
          onError={(e) => (e.currentTarget.src = use_default_dp)} // fallback if broken
          className="user-dp me-1"
          style={{ width: "38px", height: "27px", borderRadius: "50%" }}
        />
        {value || "N/A"}
      </span>
    );
  }else if (headerItem.highlightName) {
        if (content == 1) {
          return <span className="reuseableEditable-highlight-text user-mail-re-send-highlight-color" onClick={() => sendsermail(item.auth_id)}>Resend</span>;
        } else if (content == 0) {
          return <span className="reuseableEditable-highlight-text user-mail-send-highlight-color" onClick={() => sendsermail(item.auth_id)}>Send</span>;
        } else {
          return <span className="reuseableEditable-highlight-text">{content}</span>;
        }
    } 
    else {
      return <span>{content}</span>;
    }
  }
  

};

const handleCheckChange = (id) => {
  setCheckedItems(prevCheckedItems => ({
      ...prevCheckedItems,
      [id]: !prevCheckedItems[id]
  }));
};

const handleCloseeditalert = () => {
  setOpeneditalert(false);
  setEditableRow(null);
  setEditedValues({});
};

const handleSaveClickconfirmed = () => {
setOpeneditalert(false)
handleSaveClick()
}
const handleSavealert = () => {
  setOpeneditalert(true)
}


const getUserPermission = async () => {
  try {
      const response = await dispatch(getUserRole());
          const rawPermissions = response?.data?.permissions;
          const parsedPermissions = typeof rawPermissions === "string"
              ? JSON.parse(rawPermissions)
              : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
              ? JSON.parse(rawPermissions[0])
              : rawPermissions;
              console.log(parsedPermissions.filter(item => item.section == "Configuration" && item.module === "User & Role Management"));
              parsedPermissions.forEach((item) => {
                const { section, module, sub_module } = item;
    
                if (section === "Configuration" && module === "User & Role Management") {
                    const employeePermission = sub_module.find(sub => sub.name === 'Create Users');
                    if (employeePermission?.action) {
                        setCreateData(employeePermission.action.create);
                        setEditData(employeePermission.action.edit);
                        setDeleteData(employeePermission.action.delete);
                    }
                }
            });

  } catch (err) {
    console.error("Failed to fetch states:", err);
  }

};
useEffect(() => {
getUserPermission();
}, [dispatch]);
  return (
    <div className="contaner-fluid m-0 p-0">
      <div className="user-main-container">
        <div className="user-main-lable">
          <h5  className={`${activeTab == "Registers" ? "text-dark" : "text-white"}`}>Create User</h5>
          <p  className={`${activeTab == "Registers" ? "text-dark" : "text-white"}`}>Add a user and assign them a role.</p>
        </div>
      </div>
      
      <div className=" user-main-container-table">
        {/* For table-related css please refer  FormsEditableTable.css */}
    <div className='container-fluid FormsTable-main-contaner '>
      <div className='row FormsTable-main'>
          <div className="table-header">
            <div className="row d-flex">
                {/* <form onSubmit="" className='p-0 m-0'> */}
                  <div className="col d-flex justify-content-between  pe-1">
                    <div className="title-data d-flex"><div className="table_main_img"><img src={mainIcon} alt="noImg" className='dataImg' /></div>
                      <p className="dataTitle">Users List</p> 
                      <div className="FormsTable-search-box position-relative">
                        <input
                          type="text"
                          className=""
                          placeholder="Search here..."
                          style={{
                            backgroundColor: "#f9fafb",
                            border: "none",
                            width: "250px"
                          }}
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <i
                        className="bi bi-search position-absolute"
                        style={{
                          top: "39%",
                          left: "20px",
                          transform: "translateY(-50%)",
                          color: "#9ca3af"
                        }}
                        ></i>
                      </div>
                    </div>
                    <div className='float-end d-flex'>                  
                      {/* <button className='formsTable_icon_btn' type='submit' value="downloadData"><img src={download_icon} alt="noImg" className='download_icon p-0 m-0' /></button> 
                      <button className='formsTable_icon_btn' type='submit' value="deleteData"><img src={delete_icon} alt="noImg" className='delete_icon p-0 m-0' /></button>  */}
                      <div className="filter_or_createcomponentn">
                        {createData &&
                        <>
                          <button className="" onClick={createmodalhandleOpen} >Create User</button>
                        <CreateUserTemplate
                          open={createopen}
                          handleClose={createmodalhandleClose}
                          formValues={createformValues}
                          handleChange={createmodalhandleChange}
                          handleSubmit={createmodalhandleSubmit}
                          setcreateFormValues={setcreateFormValues}
                          roles={roleData}
                          adminUserNames={adminUserNames}
                          userData = {userData}
                          shouldShowAdminSelect = {shouldShowAdminSelect}
                        />
                        </>}
                      </div> 
                    </div>
                  </div>
                  <div className="table-body bg-light p-0">
                    <div className="table-responsive reuseableEditable">
                      <table className='table p-0 m-0' id='dataTable'>
                      <thead>
                          <tr>
                            {/* <th><input type="checkbox" className='' name="" id=""  checked={isAllChecked} onChange={handleCheckAll}/></th> */}
                            <th><img src={slno_icon} alt="noImg" className='headerIcon' />SL No.</th>
                            {header?.map((headerItem) => (
                              <th
                                  key={headerItem.key}
                                  onClick={() => handleSort(headerItem.key)}
                                  style={{ cursor: "pointer" }}
                                  className=""
                              >
                                <img src={headerItem.icon} alt="noImg" className='headerIcon' /> {headerItem.value} {getSortIcon(headerItem.key) &&<img src={getSortIcon(headerItem.key)} alt="" className='arrow_img'/>}
                              </th>
                            ))}
                            {editData === true || deleteData === true ? (
                              <th><img src={action_icon} alt="noImg" className='headerIcon' />Action</th>
                             ) : (<></>)}
                          </tr>
                        </thead>
                            <tbody>
                              {currentRecords.length > 0 ? (
                                currentRecords.map((item, index) => (
                                  <tr key={item.auth_id} data-id={item.auth_id}>
                                    {/* <td className="tabletdheight">
                                      <div className="table-td-div">
                                        <span>
                                        <input
                                          type="checkbox"
                                          className=''
                                          checked={checkedItems[item.auth_id] || false}
                                          onChange={() => handleCheckChange(item.auth_id)}
                                        />
                                        </span>
                                      </div>
                                    </td> */}

                                    <td className="tabletdheight">
                                      <div className="table-td-div mt-1">
                                        {indexOfFirstRecord + index + 1}
                                      </div>
                                    </td>

                                    {header.map((headerItem) => (
                                      
                                      <td key={headerItem.key} className="tabletdheight">
                                        <div className="table-td-div">
                                          {renderCell(item, headerItem)}
                                        </div>
                                      </td>
                                    ))}


                                    {(editData || deleteData) && (
                                      <td className="text-center">
                                        {editableRow === item.auth_id ? (
                                          <div className="d-flex justify-content-between">
                                            <span
                                              onClick={() => handleSavealert()}
                                              className=" p-0"
                                            >
                                              <i className="bi bi-floppy2-fill text-success auction-btn" style={{ cursor:"pointer" }} ></i>
                                            </span>
                                            <span
                                              onClick={handleCancelClick}
                                              className=" p-0"
                                            >
                                              <i className="bi bi-x-circle text-info auction-btn" style={{ cursor:"pointer" }}></i>
                                            </span>
                                          </div>
                                        ) : (
                                          <div className="d-flex ">
                                            {editData && (
                                              <span
                                                onClick={() => handleEditClick(item.auth_id)}
                                                className=" p-0"
                                              >
                                                <div className="action_icon action_edit_icon"><img src={table_edit_icon} alt="" className='edit_icon'/></div>
                                              </span>
                                             )}
                                             {deleteData && (
                                              <span
                                                onClick={() =>
                                                                                          handledeleteuserClickOpenalert(item.auth_id)
                                                                                      }
                                                className=" p-0"
                                              >
                                                <div className="action_icon action_delete_icon"><img src={table_delete_icon} alt="" className='delete_icon'/></div>
                                              </span>
                                            )}
                                          </div>
                                        )}
                                      </td>
                                    )}
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={header.length + 2}
                                    className="text-center fs-3 fw-bold text-muted"
                                  >
                                    No Record Available
                                  </td>
                                </tr>
                              )}
                            </tbody>

                      </table>
                    </div>
                  </div>
                {/* </form> */}
              <div className="col-md-12">
              <div className="pagination align-items-center justify-content-between mt-3 row">
                <div className="col-md-12 text-center">
                <div>
                  {/* Prev button */}
                  <button
                    className="page-btn-arrow"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    &lt;
                  </button>

                  {(() => {
                    const pages = [];

                    if (totalPages <= 10) {
                      // Show all pages if small count
                      for (let i = 1; i <= totalPages; i++) {
                        pages.push(i);
                      }
                    } else {
                      pages.push(1); // Always show first

                      // Left ellipsis
                      if (currentPage > 4) {
                        pages.push("...");
                      }

                      // Sliding window around current page
                      const start = Math.max(2, currentPage - 2);
                      const end = Math.min(totalPages - 1, currentPage + 2);

                      for (let i = start; i <= end; i++) {
                        pages.push(i);
                      }

                      // Right ellipsis
                      if (currentPage < totalPages - 3) {
                        pages.push("...");
                      }

                      pages.push(totalPages); // Always show last
                    }

                    return pages.map((p, idx) =>
                      p === "..." ? (
                        <span key={`ellipsis-${idx}`} className="ellipsis">
                          ...
                        </span>
                      ) : (
                        <button
                          key={p}
                          className={`page-btn ${currentPage === p ? "active" : ""}`}
                          onClick={() => handlePageChange(p)}
                        >
                          {p}
                        </button>
                      )
                    );
                  })()}

                  {/* Next button */}
                  <button
                    className="page-btn-arrow"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    &gt;
                  </button>
                </div>

                </div>

                <div className="col-md-12">
                <div className="row float-end">
                <div className="d-flex align-items-center showPerPage">
                  <span className="me-2">Show per page:</span>
                  <select
                    value={recordsPerPage}
                    onChange={(e) => {
                      setRecordsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                  >
                    {getPageSizeOptions(sortedData.length).map((size, i) => (
                      <option key={i} value={size}>
                        {size === sortedData.length ? "All" : size}
                      </option>
                    ))}
                  </select>
                </div>
                </div>
                </div>
              </div>
              </div>

            </div>
          </div>
      </div>
      
      {/* 
      <Dialog
          open={opendeletealert}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
      >
          <DialogTitle>{"Are you sure?"}</DialogTitle>
          <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                  Are you sure you want to delete this {title}? This action cannot be undone.

              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button onClick={handledeleteClosealert}>No</Button>
              <Button onClick={handledeleteClickconfirmed}>Yes</Button>
          </DialogActions>
      </Dialog>
      <Dialog
          open={opendeletemultialert}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
      >
          <DialogTitle>{"Are you sure?"}</DialogTitle>
          <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                  Are you sure you want to delete those {title}? This action cannot be undone.

              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button onClick={handledeletemultiClosealert}>No</Button>
              <Button onClick={selectedDelete}>Yes</Button>
          </DialogActions>
      </Dialog> */}
      
      <Dialog
        open={openUserdeletealert}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Are you sure?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Are you sure you want to delete this user ? This action cannot be undone.

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleuserdeleteClosealert}>No</Button>
          <Button onClick={handleDeleteClick}>Yes</Button>
        </DialogActions>
      </Dialog>
      <Dialog
          open={openeditalert}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
      >
          <DialogTitle>{"Are you sure?"}</DialogTitle>
          <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                  Are you sure you want to edit this User? Any unsaved changes might be lost.
              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button onClick={handleCloseeditalert}>No</Button>
              <Button onClick={handleSaveClickconfirmed}>Yes</Button>
          </DialogActions>
      </Dialog>
    </div>
      </div>
    </div>
  )
}

export default CreateUsers
